import { gql } from '@apollo/client';

// Filters playerPlays at the server using the player-play-level drawnPenalty
// flag, returning roughly one row per drawn penalty (~1 vs 22 per play).
// Requires amf-iq-api#712 (drawnPenalty filter) to be deployed.
export const GET_GAME_DRAWN_PENALTIES = gql`
  query GetGameDrawnPenalties($competitionId: Int!, $gameId: [Int!]) {
    selectedCompetitionId @client @export(as: "competitionId")
    selectedGameId @client @export(as: "gameId")

    playerPlays(
      first: 1000
      filters: {
        competitionId: $competitionId
        gameIds: $gameId
        drawnPenalty: true
      }
    ) {
      edges {
        node {
          play {
            id
          }
          player {
            id
            name
            knownName
          }
        }
      }
    }
  }
`;

export const GET_GAME_OVERVIEW = gql`
  query GetGameOverview($competitionId: Int!, $gameId: [Int!]) {
    selectedCompetitionId @client @export(as: "competitionId")
    selectedGameId @client @export(as: "gameId")

    plays(
      first: 1000
      includeT1Games: true
      filters: {
        competitionId: $competitionId
        gameIds: $gameId
        includeNegated: true
      }
    ) {
      edges {
        node {
          id
          name
          gameIndex
          driveIndex
          quarter
          quarterClockRemaining
          down
          yardsToGo
          yardLine
          type
          yardsNet
          yardsRun
          passYardsAir
          scrimmageEpa
          explosive
          success
          firstDownWon
          touchdownWon
          pointsWon
          turnoverType
          downNegated
          qbHit
          qbSacked
          offensivePersonnel
          defensivePersonnel
          formationGroup
          defensiveCoverage
          mofo
          drawnPenalty
          backfieldNumRbs
          offensePenaltyAccepted
          defensePenaltyAccepted
          penaltyOffset
          penaltyYards
          penaltyFirstDown
          penaltyDownLoss
          penalties {
            type
            name
          }
          homeScore
          awayScore
          offenseTeam {
            id
            name
            shortName
          }
          defenseTeam {
            id
            name
            shortName
          }
          drive {
            id
            name
            gameIndex
            playCount
            startQuarter
            quarterClockRemaining
            startingYards
            yardsNet
            offensePoints
            defensePoints
            team {
              id
              name
            }
          }
          game {
            id
            date
            roundName
            roundShortName
            dataComplete
            t1DataOnly
            homeScore
            awayScore
            homeTeam {
              id
              name
              shortName
              colorPrimary
              colorSecondary
              colorTertiary
            }
            awayTeam {
              id
              name
              shortName
              colorPrimary
              colorSecondary
              colorTertiary
            }
          }
        }
      }
    }
  }
`;
